import FrequentSearches from './FrequentSearches.vue'

export default FrequentSearches
